module.exports = __webpack_public_path__ + "static/media/bluePhone.7a436455.svg";